import { defineMessages } from 'react-intl';

export default defineMessages({
  monthLabel: {
    id: 'neptune.DateInput.month.label',
    defaultMessage: 'Month',
  },
  dayLabel: {
    id: 'neptune.DateInput.day.label',
    defaultMessage: 'Day',
  },
  yearLabel: {
    id: 'neptune.DateInput.year.label',
    defaultMessage: 'Year',
  },
  dayPlaceholder: {
    id: 'neptune.DateInput.day.placeholder',
    defaultMessage: 'DD',
    description: 'Placeholder for 2-digit day values within an input.',
  },
  yearPlaceholder: {
    id: 'neptune.DateInput.year.placeholder',
    defaultMessage: 'YYYY',
    description: 'Placeholder for 4-digit year values within an input.',
  },
});
